var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZeroHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.5V10.5C9.5 9.11929 10.6193 8 12 8C13.3807 8 14.5 9.11929 14.5 10.5V13.5C14.5 14.8807 13.3807 16 12 16C10.6193 16 9.5 14.8807 9.5 13.5Z",
    stroke: "#0F172B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.8008V8.19922C20.4997 7.86596 20.4122 7.53865 20.2465 7.25013C20.0807 6.96161 19.8424 6.72201 19.5556 6.55538L12.9444 2.7546C12.6573 2.58781 12.3316 2.5 12 2.5C11.6684 2.5 11.3427 2.58781 11.0556 2.7546L4.44444 6.55538C4.15758 6.72201 3.91931 6.96161 3.75355 7.25013C3.58778 7.53865 3.50034 7.86596 3.5 8.19922V15.8008C3.50034 16.134 3.58778 16.4613 3.75355 16.7499C3.91931 17.0384 4.15758 17.278 4.44444 17.4446L11.0556 21.2454C11.3427 21.4122 11.6684 21.5 12 21.5C12.3316 21.5 12.6573 21.4122 12.9444 21.2454L19.5556 17.4446C19.8424 17.278 20.0807 17.0384 20.2465 16.7499C20.4122 16.4613 20.4997 16.134 20.5 15.8008Z",
    stroke: "#0F172B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroHexagon);
export default __webpack_public_path__ + "static/media/zero-hexagon.c40a9530bdad35e4d23919493958f00f.svg";
export { ForwardRef as ReactComponent };